import React, { FC, useEffect, useState } from 'react';
import NavigationBar from './NavigationBar';
import { TPrivacyStatementProps } from '../../types/PrivacyStatement.types';
import { PrivacyStatementModel } from '../../models/PrivacyStatement.model';
import SectionContent from '../SectionContent';
import { documentService, windowService } from '../../../../utils/window.utils.js';
import Dropdown from '../Dropdown';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { generatePDF } from '../../../../utils/generatePDF';
import './index.scss';

const MobilePrivacyStatement: FC<TPrivacyStatementProps> = (props: TPrivacyStatementProps) => {
  const model = new PrivacyStatementModel(props);
  const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
  const typeCollectionMap = model.typeCollection;
  const { t } = useTranslation();
  const [language, setLanguage] = useState<string | null>('');
  const [type, setType] = useState<string>('');
  const navigate = useNavigate();
  const [langCollection, setLangCollection] = useState<string[]>(() => {
    const typ = getQuery('type');
    return (typ ? typeCollectionMap.get(typ) : typeCollectionMap.values().next().value) ?? []
});

  useEffect(() => {
    documentService()?.body.scrollIntoView();
    const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
    const lngQuery = getQuery('lan');
    const typQuery = getQuery('type');
    if (lngQuery && typQuery) {
      setLanguage(lngQuery);
      setType(typQuery)
    }
  }, []);

  const onTypeSelect = (type: string) => {
    setType(type);
    setLangCollection(typeCollectionMap.get(type) ?? []);
    setLanguage('');
  }

  const updateUrlQueryStringParams = (): void => {
    const getQuery = () => new URLSearchParams(windowService().location?.search);
    const queries = getQuery();

    const updateUrlParams = (key, newVal: string) => {
      if (newVal.trim() !== '') {
        queries.set(key, newVal);
      } else {
        queries.delete(key);
      }
    };

    updateUrlParams('code', language ?? '');
    updateUrlParams('brand', type ?? '');
    navigate(`?${queries.toString()}`);
  };

  return (
    <section className="privacy-statement-v2-mobile">
      <div className="privacy-statement-v2__title">{model.title.value}</div>
      <Dropdown
        Collection={model.typeCollectionArray}
        changeTitle={model.typeTitle?.value || ''}
        defaultTitle={model.defaultLanguageTitle?.value || ''}
        onSelect={onTypeSelect}
        preSelected={type}
      />
      <Dropdown
        Collection={[...langCollection]}
        changeTitle={model.languageTitle?.value || ''}
        defaultTitle={model.defaultLanguageTitle?.value || ''}
        onSelect={setLanguage}
        preSelected={language ?? ''}
      />
      <div className={'privacy-statement-v2__dropdown__cta-container'}>
        <div className="privacy-statement-v2__button privacy-statement-v2__button-primary-red privacy-statement-v2__dropdown__primary-cta">
          <button onClick={() => generatePDF()}>
            <Text tag={'div'} field={{ value: t('cnhi-generate-pdf') as string }} editable={false} /></button>
        </div>
        <div className="privacy-statement-v2__button privacy-statement-v2__button-primary-red privacy-statement-v2__dropdown__primary-cta">
          <button
            onClick={() => {
                if (language && type) {
                   updateUrlQueryStringParams();
                }
              }
            }><Text tag={'div'} field={{ value: t('cnhi-submit') as string }} editable={false} /></button>
        </div>
      </div>
      {model?.items ? <NavigationBar privacyContentItems={model.items} /> : <div></div>}
      <section className="privacy-statement-v2__content">
        {
          model?.items ?
            model?.items && model.items.map((item) => {
              return (
                <div className="privacy-statement-v2__content-tab" id={item.id}>
                  <SectionContent {...item} />
                </div>
              )
            }) : <div>{model.defaultEmptyMessage.value}</div>
        }
      </section>
    </section>

  )
};

export default MobilePrivacyStatement;
